import { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";

import classes from "../maintainers.module.scss";

import { validRoles } from "@/services/Utils";
import { customStyles } from "./varieties.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const VarietiesFilter = ({ filter, applyFilter }) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const { customers, estates, categories, species } = useSelector((state) => state.maintainers_varieties);

	const [customerFilter, setCustomerFilter] = useState(filter.filter_customer);
	const [estateFilter, setEstateFilter] = useState(filter.filter_estate);
	const [specieFilter, setSpecieFilter] = useState(filter.filter_specie);
	const [categoryFilter, setCategoryFilter] = useState(filter.filter_category);

	const handleApplyFilter = () => {
		applyFilter({
			customerFilter,
			estateFilter,
			specieFilter,
			categoryFilter,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			customerFilter: "",
			estateFilter: "",
			specieFilter: "",
			categoryFilter: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				{isAdmin && (
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Cliente</span>
						</Col>
						<Col md={12}>
							<Select
								value={
									customers &&
									customers.filter(
										(a) =>
											customerFilter && customerFilter.length > 0 && _.map(customerFilter.split(","), Number).includes(Number(a.value)),
									)
								}
								isMulti
								placeholder={<div>Seleccione</div>}
								options={customers ? customers : []}
								onChange={(value) => {
									let baseValue = [];
									value.forEach((element) => {
										baseValue.push(element.value);
									});

									setCustomerFilter(baseValue.length !== 0 ? baseValue.toString() : "");
								}}
								components={{ NoOptionsMessage }}
								styles={customStyles}
							/>
						</Col>
					</Row>
				)}

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Campo</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								estates &&
								estates.filter(
									(a) => estateFilter && estateFilter.length > 0 && _.map(estateFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={estates ? estates : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setEstateFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Categorías</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								categories &&
								categories.filter(
									(a) => categoryFilter && categoryFilter.length > 0 && _.map(categoryFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={categories ? categories : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setCategoryFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Paso 1</span>
					</Col>
					<Col md={12}>
						<Select
							value={
								species &&
								species.filter(
									(a) => specieFilter && specieFilter.length > 0 && _.map(specieFilter.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={species ? species.filter((s) => _.map(categoryFilter, Number).includes(Number(s.category_id))) : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setSpecieFilter(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default VarietiesFilter;
